const loyaltyConstants = {
	vipTiers: {
		currentStatusLabel: "current status",
		benefitHeaders: [
//			"discount on every order",
            "welcome discount x1",
			"free shipping*",
			"birthday gift",
			"pre-access to sale",
			"fast-track customer support - responses within 2 hours*",
//			"priority mdv event access",
            "free returns*"
		
			
		],
		benefitHeadersTitle: "rewards",
		benefitsList: [
			{
				tierId: 12894,
				tierRequirement: "spend €1,000-€1,249",
				benefits: [
//					"5%",
					"15%",
                    "standard",
					"●",
					"●",
					"",
//                  " ",
					" "
				]
			},
			{
				tierId: 12895,
				tierRequirement: "spend €1,250-€2,499",
				benefits: [
//					"10%",
					"25%",
                    "express",
					"●",
					"●",
					"●",
//                  " ",
					" "
				]
			},			
			{
				tierId: 12896,
				tierRequirement: "spend €2,500+",
				benefits: [
//					"15%",
					"50%",
                    "express",
					"●",
					"●",
					"●",
//                  "●",
	                "●"
				]
			}
			

		]

	}
	
}
